module.exports = __webpack_public_path__ + "static/assets/3fcb8177b4b08d9ac19f8cf5a0bdca13.png";